import React, { useState, useEffect } from "react";
import { Layout, Menu, Drawer, Button } from "antd";
import { Link } from "react-router-dom";
import { CameraOutlined, MenuOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom"; // Import useLocation hook
import { useData } from "../contexts/DataContext";

const { Header } = Layout;

const Navbar: React.FC = () => {
  const { state } = useData();
  const [open, setOpen] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation(); // Get current location

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < prevScrollY;

      setIsScrolled(isScrollingUp || currentScrollY === 0); // Show navbar when scrolling up or at top

      setPrevScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollY]);

  const handleDrawerOpen = () => {
    setOpen(true);
    // Lock scrolling of the main content when the drawer is open
    document.body.style.overflow = "hidden";
  };

  const handleDrawerClose = () => {
    setOpen(false);
    // Restore scrolling of the main content when the drawer is closed
    document.body.style.overflow = "auto";
  };

  const menuItems = [
    { key: "home", label: "Home", to: "/" },
    { key: "portfolio", label: "Portfolio", to: "/portfolio" },
    { key: "blog", label: "Blog", to: "/blog" },
    { key: "pricing", label: "Pricing", to: "/pricing" },
    { key: "inquire", label: "Inquire", to: "/inquire" },
  ];

  const selectedMenuKey =
    menuItems.find((item) =>
      item.to === "/"
        ? location.pathname === item.to
        : location.pathname === item.to ||
          location.pathname.startsWith(`${item.to}/`)
    )?.to ?? "";

  return (
    <Header
      style={{
        position: "sticky",
        zIndex: 1000,
        background: "white",
        transition: "top 0.3s ease-in-out",
        top: isScrolled ? "0" : "-60px", // Show navbar if scrolled or at top
      }}
    >
      {/* Mobile bar */}
      {state.isMobile && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "60px",
            overflow: "hidden",
          }}
        >
          <Link
            to="/"
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <img
              src="ami-logo.jpg"
              alt="Logo"
              style={{
                height: "80%",
                width: "auto",
                display: "block",
              }}
            />
          </Link>
          <Button
            style={{
              height: "50px",
              width: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            icon={<MenuOutlined style={{ fontSize: "24px" }} />}
            onClick={handleDrawerOpen}
          />
        </div>
      )}

      {/* Desktop bar */}
      {!state.isMobile && (
        <div style={{ textAlign: "center" }}>
          <Menu
            mode="horizontal"
            style={{ display: "flex", justifyContent: "center" }}
            selectedKeys={[selectedMenuKey]} // Highlight selected menu item
          >
            <div
              style={{
                fontFamily: "Montgaga",
                fontSize: "24px",
                marginRight: "10%",
                whiteSpace: "nowrap",
              }}
            >
              <span >ALA MODE IMAGE</span>
            </div>
            {menuItems.map((item) => (
              <Menu.Item
                key={item.to}
                style={
                  item.key === "inquire"
                    ? {
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "-10px",
                    }
                    : {}
                }
              >
                <Link to={item.to}>
                  {item.key === "inquire" && (
                    <CameraOutlined style={{ marginRight: "8px" }} />
                  )}
                  {item.label}
                </Link>
              </Menu.Item>
            ))}
          </Menu>
        </div>
      )}

      <Drawer
        placement="right"
        closable={false}
        onClose={handleDrawerClose}
        maskClosable={true}
        visible={open} // Use 'visible' prop instead of 'open'
        width={200} // Set drawer width
        bodyStyle={{ padding: "0" }} // Remove default padding
        headerStyle={{ textAlign: "right" }} // Align header text to right
        style={{ alignContent: "center", paddingTop: "20vh" }}
      >
        <Menu
          mode="vertical"
          style={{ textAlign: "center" }}
          selectedKeys={[selectedMenuKey]}
        >
          {menuItems.map((item) => (
            <Menu.Item
              key={item.to}
              onClick={handleDrawerClose}
              style={
                item.key === "inquire"
                  ? {
                    fontSize: "1.5rem",
                    height: "60px",
                    lineHeight: "60px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "-10px",
                  }
                  : { fontSize: "1.5rem", height: "60px", lineHeight: "60px" }
              }
            >
              {item.key === "inquire" ? (
                <Link to={item.to}>
                  {item.key === "inquire" && (
                    <CameraOutlined
                      style={{ marginRight: "8px", verticalAlign: "middle" }}
                    />
                  )}
                  {item.label}
                </Link>
              ) : (
                <Link to={item.to}>{item.label}</Link>
              )}
            </Menu.Item>
          ))}
        </Menu>
      </Drawer>
    </Header>
  );
};

export default Navbar;
